import {
  FactionBossLeaderboardResponse,
  FactionFeudsResponse,
  FactionLeaderboardTopResponse,
  PlayerFeudLeaderboardResponse,
  PlayerLeaderboardTopResponse,
  RbeLeaderboardResponse,
} from '@wwe-portal/entities/leaderboard.type';
import { nestApiClient } from './api-client';

export const getFactionFeuds = (params: {
  eventsSkip: number;
  eventsCount: number;
}) => {
  return nestApiClient.get<FactionFeudsResponse>('/api/v1/leaderboard/main', {
    params,
  });
};

export const getPlayerLeaderboardTop = (params: {
  category: string | number;
  skip: number;
  limit: number;
}) => {
  return nestApiClient.get<PlayerLeaderboardTopResponse>(
    '/api/v1/leaderboard/players/type',
    { params }
  );
};

export const getFactionLeaderboardTop = (params: {
  category: string | number;
  skip: number;
  limit: number;
}) => {
  return nestApiClient.get<FactionLeaderboardTopResponse>(
    '/api/v1/leaderboard/faction/type',
    { params }
  );
};

export const getFactionBossLeaderboard = ({
  eventId,
  ...params
}: {
  skip: number;
  limit: number;
  type: string;
  eventId: string;
}) => {
  return nestApiClient.get<FactionBossLeaderboardResponse>(
    `/api/v1/leaderboard/${eventId}`,
    { params }
  );
};

export const getPlayerFeudLeaderboard = ({
  eventId,
  ...params
}: {
  skip: number;
  limit: number;
  eventId: string;
}) => {
  return nestApiClient.get<PlayerFeudLeaderboardResponse>(
    `/api/v1/leaderboard/${eventId}`,
    {
      params: {
        ...params,
        type: 'players',
      },
    }
  );
};

export const getRbeLeaderboard = (params: {
  eventId: string;
  skip: number;
  limit: number;
}) => {
  return nestApiClient.get<RbeLeaderboardResponse>(`/rbe/v2/leaderboard`, {
    params,
  });
};
